import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import styles from './InputChips.styles.m.css';
import { IInputChipsProps } from './InputChips.types';
import { InputChipsItem } from './InputChipsItem/InputChipsItem';

// TODO подумать над слиянием с компонентом Chips
// сейчас старый компонент заточен под горизонтальный скролл и свои габаритные размеры для анимации
// также он требует рефакторинга и проверки на проекте мессенджера, тк внутри итемов из коробки содержит комопнент Avatar

export const InputChips: FC<PropsWithChildren<IInputChipsProps>> = (props) => {
  const {
    chips,
    keyExtractor,
    onRemove,
    onClick,
    isDisabled,
    className,
    theme = 'standard',
    children,
  } = props;

  const containerClassName = classNames(styles.container, className);

  return (
    <ul className={containerClassName}>
      {chips.map((item) => (
        <li
          className={styles.listItem}
          key={keyExtractor ? keyExtractor(item) : item.id}
        >
          <InputChipsItem
            Icon={item.Icon}
            theme={item.theme || theme}
            id={item.id}
            isDisabled={isDisabled}
            onRemove={item.onRemove || onRemove}
            onClick={onClick}
            className={classNames(styles.item, item.className)}
          >
            {item.children}
          </InputChipsItem>
        </li>
      ))}
      {children}
    </ul>
  );
};
